import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderComponent } from './componentes/header/header.component';
import { SidenavComponent } from './componentes/sidenav/sidenav.component';
import { EsqueletoInteriorComponent } from './componentes/esqueleto-interior/esqueleto-interior.component';
import { PaginaPrincipalComponent } from '../interior/paginas/pagina-principal/pagina-principal.component';

import { InteriorRoutingModule } from './interior-routing.module';
import { FormularioModule } from '../compartido/formulario/formulario.module';
import { AutorizacionModule } from '../compartido/autorizacion/autorizacion.module';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';

@NgModule({
  declarations: [
    HeaderComponent,
    SidenavComponent,
    EsqueletoInteriorComponent,
    PaginaPrincipalComponent,
  ],
  imports: [
    CommonModule,

    InteriorRoutingModule,
    FormularioModule,
    AutorizacionModule,

    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatStepperModule,
    MatMenuModule,
    MatBadgeModule,
    MatDividerModule,
    MatListModule,
  ],
})
export class InteriorModule {}
